import { useQuery } from '@apollo/client';

import { SearchSavedAndAppliedJobsDocument } from 'src/graphql/graphql';
import { getUseUpdateSearchSavedAndAppliedJobsCache } from 'src/hooks/useSaveJob/utils/useSavedJobsData';
import { useToggleSavedJob } from 'src/hooks/useSaveJob/utils/useToggleSavedJob';
import { useSelector } from 'src/store/react';
import { selectAuthenticated } from 'src/store/user/selectors';

export const useSavedJobsDataCP = ({
  jobIds,
  shouldSkip = false,
}: {
  jobIds: string[];
  shouldSkip?: boolean;
}) => {
  const isAuthenticated = useSelector(selectAuthenticated);

  const searchSavedAndAppliedJob = useQuery(SearchSavedAndAppliedJobsDocument, {
    skip: !Boolean(jobIds?.length) || shouldSkip || !isAuthenticated,
    variables: { jobIds },
    ssr: false,
  });

  return searchSavedAndAppliedJob;
};

export const getUseSaveJobCompetitiveJob = (jobIds: string[]) => {
  const useUpdateCPSavedAndAppliedJobsCache =
    getUseUpdateSearchSavedAndAppliedJobsCache(jobIds);

  return ({ jobId }: { jobId: string }) => {
    const savedJobsData = useSavedJobsDataCP({ jobIds });
    const { setSaved, setUnsaved } = useUpdateCPSavedAndAppliedJobsCache(jobId);
    const savedJobMutation = {
      create: { update: setSaved },
      delete: { update: setUnsaved },
    };
    const { isSaved, isApplied, toggleSavedJob } = useToggleSavedJob({
      jobId,
      view: 'jobDetails',
      linkPosition: 'listing',
      savedJobsData: savedJobsData?.data,
      savedJobMutation,
      // todo add tracking data here later
      // jobTracking, // used as SERP tracking
    });

    return {
      isSaved,
      toggleSavedJob,
      isApplied,
    };
  };
};
